<template>
  <div class="flex middle column">
    <div class="w1200 w100">
      <section class="grid-flex w100 center">
        <h1>Escolha um Projeto para acessar:</h1>
      </section>
      <section class="flex w100 column middle">
        <div 
          v-for="(acc, index) in accounts" 
          :key="index" 
          class="box account" 
          style="margin-left: 0px;" 
          :class="{ 'manager': acc.account_type == 'MANAGER'}"
        >
          <div class="box-content">
            <div class="flex middle">
              <div class="flex-2">
                <div class="flex column">
                  <div>
                    <h3>{{ acc.name }}</h3>
                  </div>
                  <div>
                    <small>Tipo de Conta: {{ acc.account_type == 'MANAGER'? 'ADMINISTRADORA' : 'PROJETO' }}</small>
                  </div>
                </div>
              </div>
              <div class="flex-1 flex end">
                <div class="button primary" @click="selectAccount(acc)">
                  ENTRAR
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="flex margin-top-l w100" style="max-width: 600px;">
          <content-loading>
            <fake-line height="60"></fake-line>
            <fake-line height="60"></fake-line>
            <fake-line height="60"></fake-line>
            <fake-line height="60"></fake-line>
          </content-loading>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { AccountsList } from "@/services/user";

export default {
  name: "Account",
  components: {},
  data() {
    return {
      account: null,
      loading: true,
      accounts: [],
    };
  },
  mounted() {
    
    this.loading = true;
    AccountsList()
      .then((response) => {
        this.accounts = response;
        if (this.accounts.length) {
          this.account = this.accounts[0];
          // check exist one account...
          if (this.accounts.length === 1) {
            this.accountSelected();
          }
        }
      })
      .catch((error) => {
        if (error && error.message === "request-canceled") {
          return;
        }

        this.$toast.error({
          title: "Erro",
          message: "Falhou ao buscar contas",
        });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    listAllAccounts() {
      if (!this.accounts || (this.accounts && this.accounts.length === 0)) {
        return [];
      }

      return this.accounts.map((acc) => {
        return {
          label: `(${acc.id}) ${acc.name}`,
          value: acc,
        };
      });
    },
  },
  methods: {
    selectAccount(account) {
      this.account = account;
      this.accountSelected();
    },
    accountSelected() {
      if (!this.account) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa selecionar uma conta para entrar!",
        });
        return;
      }

      // set in store user and account selected
      this.$store.dispatch("auth", { account: this.account.id });
      this.$store.dispatch("setAccount", this.account);

      // redict to home
      this.$router.push({ name: "Home" });
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-flex {
  padding: 35px;
}

.w1200 {
  max-width: 1200px;
}

.account {
  margin-top: 16px;
  min-width: 550px;
  border: 1px solid #ebebeb;

}
.manager {
  min-width: 580px;
  border: 1px solid #c9c9c9;
}


@media only screen and (max-width: 980px) {
  .manager {
    min-width: 100px;
    width: 100%;
  }
  .account {
    min-width: 100px;
    width: 90%;
  }
}

</style>
